<template>
  <div class="container">
    <div class="top_title">
      <!-- 返回按钮 -->
      <!--      <router-link class="icon_back" :to="{ name: 'H600030' }" tag="span"></router-link>-->
      <span>课时余额查询</span>
    </div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="weui-cells item" style="border: 0 !important; margin-top: 2.4rem">

        <div class="'weui-cell weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__bd">
            <p class="request">校区</p>
          </div>
          <div class="weui-cell__ft">
            <select class="weui-select" v-model="I_SCHOOL_VALUE" style="color: #000;opacity: 1;" v-if="IsSchoolList">
              <option v-for="(item, index) in SCHOOL_LIST" style="color: #000;opacity: 1;" :key="index" :value="item.I_VALUE">
                {{ item.I_TEXT }}
              </option>
            </select>
            <input v-if="!IsSchoolList" type="text" :disabled="true" class="input_text"
                   v-model="SCHOOL_LIST[0].I_TEXT"
                   style="padding-right: 0.4rem; color: #000;margin-right:.5rem;opacity: 1;"
            />
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p class="request">手机</p>
          </div>
          <div class="weui-cell__ft">
            <input type="text" class="input_text tel" v-model="info.I_TEL" style="padding-right: 0.4rem;width:100%;color: #000;opacity: 1;"
                   placeholder="请输入家长手机号码"/>
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__bd">
            <p class="request">验证码</p>
          </div>
          <div class="weui-cell__ft identify_code">
            <input type="text" v-model="info.I_IDENTIFY_CODE" style="color: #000;opacity: 1;" placeholder="请输入验证码"/>
            <button type="button" :disabled="disabled" @click="sendcode" class="btns">{{ btntxt }}</button>
          </div>
        </div>
      </div>
      <button class="bottom_btn" @click="onClickSearch">查询</button>
    </div>
  </div>
</template>

<script>
import DataRequestFactory from "@/factories/dataRequestFactory.js";
import weui from "weui.js";
import dataRequestFactory from "../factories/dataRequestFactory";

export default {
  data() {
    return {
      SCHOOL_LIST: [{
        I_TEXT: '',
        I_VALUE: '',
      }],
      I_SCHOOL_VALUE: '',
      IsSchoolList: false,
      info: {
        I_TEL: '',
        I_IDENTIFY_CODE: '',
      },
      btntxt: "获取验证码",
      disabled: false,
    }
  },
  methods: {
    //验证手机号码部分
    sendcode() {
      // var reg=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (this.info.I_TEL == '' || this.info.I_TEL == null) {
        weui.topTips("请输入手机号码");
        // }else if(!reg.test(this.info.I_TEL)){
        //   weui.topTips("手机格式不正确");
      } else {
        this.time = 60;
        this.disabled = true;
        this.timer();
        let requestParams = {
          "I_SCHOOL_NO": this.I_SCHOOL_VALUE,
          "I_PHONE": this.info.I_TEL,
        }
        DataRequestFactory.I700011(requestParams).then((response) => {
          if (response.resultCode == '0') {
          } else {
            weui.topTips(response.errorDesc);
          }
        })
      }
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    onClickSearch() {
      let requestParams = {
        "I_SCHOOL_NO": this.I_SCHOOL_VALUE,
        "I_PHONE": this.info.I_TEL,
        "I_IDENTIFY_CODE": this.info.I_IDENTIFY_CODE,
      }
      dataRequestFactory.I700012(requestParams).then((response) => {
        if (response.resultCode == '0') {
          this.$router.push({
            name: 'H700020',
            params: {
              I_SCHOOL_NO: this.I_SCHOOL_VALUE,
              I_PHONE: this.info.I_TEL,
            }
          })
        } else {
          weui.topTips(response.errorDesc);
        }
      })
    },
  },
  mounted() {
    var win_h = $(window).height();  //关键代码
    $("body").height(win_h);  //关键代码

    let requestParams = {}
    if (this.$route.query.I_SCHOOL_NO) {
      requestParams = {
        "I_SCHOOL_NO": this.$route.query.I_SCHOOL_NO,
      }
    }
    dataRequestFactory.I700010(requestParams).then(res => {
      if (res.resultCode === '0') {
        this.IsSchoolList = res.DataCount === '1' ? false : true
        if (!this.IsSchoolList && res.DataList.length >= 1) {
          this.I_SCHOOL_VALUE = res.DataList[0].I_VALUE
        }
        this.SCHOOL_LIST = res.DataList
      } else {
        weui.topTips(response.errorDesc);
      }
    })
  }
}
</script>

<style scoped>
.request:after {
  content: '*';
  color: red;
  margin-left: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/H700010.vue